"use client";

import useReveal from "@/components/PhD/utils/useReveal";
import { revealConfig } from "@/components/PhD/utils/animationConfig";

export default function Reveal({
  children,
  delay = 0,
  className = "",
}) {
  const { ref, visible } = useReveal();

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible
          ? "translateY(0)"
          : `translateY(${revealConfig.distance}px)`,

        transition: `
          opacity ${revealConfig.duration}ms ${revealConfig.easing} ${delay}ms,
          transform ${revealConfig.duration}ms ${revealConfig.easing} ${delay}ms
        `,
      }}
    >
      {children}
    </div>
  );
}